import React, { useState, useEffect, useRef } from "react";
import DataTable from "../../../../Components/UiComponents/DataTable";
import HeaderSearchBar from "../../../../Components/UiComponents/HeaderSearch";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import "react-toastify/dist/ReactToastify.css";
import { InputIcon } from "primereact/inputicon";
// Components
import CreateNewUsers from "./CreateNewUsers";
import EditUsers from "./EditUsers";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
// Services
import _ from "lodash";
import { list } from "../../../../Services/branchService";
import {
  getCustomerControlField,
} from "../../../../Services/customerServices";
import Loader from "../../../../Components/UiComponents/Loader";
import {
  getUsersList,
  filter,
  getuserbyid,
  bySeqId,
} from "../../../../Services/userService";
import { getAllRoles } from "../../../../Services/roleService";
import { get } from "../../../../Services/customerServices";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";

export default function Users(props) {
  const [customerId, setCustomerId] = useState(null);
  const [branch, setBranch] = useState(null);
  const [custmerReferenceData, setCustmerReferenceData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [position, setPosition] = useState("center");
  const [customerControlFields, setCustomerControlFields] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [customerOptions, setCustomerOptions] = useState({});
  const [editUser, setEditUser] = useState([]);
  const [promptTabs, setPromptTabs] = useState([]);
  const [searchedLength, setSearchedLength] = useState(0);
  const toastRef = useRef();
  const [totalRecords, setTotalRecords] = useState(0);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: -1,
    sortField: "last_login",
    sortOrder: 1,
  });
  const [loading, setLoading] = useState(false);
  const [havingBranch, setHavingBranch] = useState(false);
  const [branchAdmin, setBranchAdmin] = useState(false);
  const [adminVisible, setAdminVisible] = useState(false);
  const [tmpData , setTmpData] = useState(null);
  const [showVideo, setShowVideo] = useState(false);
  const navigate = useNavigate()

  useEffect(() => {
    // Fetching end user data from local storage
    const enduserStr = localStorage.getItem("enduser");
    // Checking if end user data exists in local storage
    if (enduserStr) {
      // Parsing end user data
      const enduser = JSON.parse(enduserStr);
      // Extracting customer information from end user data
      const customer = enduser.customer;
      setTmpData(enduser)
      // Setting customer ID state
      setCustomerId(customer);
      setBranch(enduser.branch);
      setBranchAdmin(enduser.isBranchAdmin)
    } else {
      navigate("/login")
      localStorage.clear()
    }

  }, []);

  useEffect(() => {
    // Fetching customer field data
    getCustomerField();
    // Fetching customer control data
    getCustomerControl();
    getCustomer();
    getBranchList();
    getRoles();
  }, [customerId]);

  useEffect(() => {
    getCustomerField();
  }, [lazyParams])

  // Function to get customer reference data.
  const getCustomer = async () => {
    try {
      if (customerId === null) {
        return;
      }
      if (customerId) {
        const customer = await get(customerId);
        if (customer) {
          var havingBranch = customer?.data.havingBranch;
          setHavingBranch(havingBranch)
          // BusinessUnit
          const refDataBusinessUnit = customer?.data?.reference_data?.find(
            (item) => item.option_names === "BusinessUnit"
          );
          if (refDataBusinessUnit && refDataBusinessUnit.option_choice) {
            const activeOptions = refDataBusinessUnit.option_choice.filter(
              (option) => option.status === "active"
            );
            setCustomerOptions((prevState) => ({
              ...prevState,
              BusinessUnitOpts: activeOptions,
            }));
          }
        }
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };
  // Function to get branches.
  const getBranchList = async () => {
    try {
      if (customerId === null) {
        return;
      }
      if (customerId) {
        const branch = await list(customerId, "branch_name", -1);
        if (branch) {
          const allBranches = branch?.data.branch;
          if (tmpData && !tmpData.isAdmin && tmpData.isBranchAdmin) {
            var branches = tmpData.branch;
          } else {
            var index = _.findIndex(allBranches, { branch_key: 'main' });
            if (index != -1) {
              var branch_id = allBranches[index]._id;
              var branch_key = allBranches[index].branch_key;
              setAdminVisible(true)
            }
          }
          let optionList = allBranches.map((item) => ({
            id: item._id,
            label: item.branch_name,
            branch_key: item.branch_key,
          }));
          setCustomerOptions((prevState) => ({
            ...prevState,
            Branches: optionList,
          }));
        }
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };


  // Function to fetch users data from the server
  const getCustomerField = async () => {
    try {
      if (customerId === null) {
        return;
      }
      setLoading(true);
      // Ensure customerId is not null
      if (customerId !== null) {
        const { first, rows, sortField, sortOrder } = lazyParams;
        const skip = first;
        const limit = rows;
        const orderBy = sortOrder;
        const sortBy = sortField;
        //skip, limit, cust_id, pattern, sortBy, orderBy
        const customerData = await filter(
          skip,
          limit,
          customerId,
          searchQuery,
          sortBy,
          orderBy,
          branch
        );
        setTotalRecords(customerData?.data?.count);
        setCustmerReferenceData(customerData?.data?.users);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };
  // Function to fetch and set roles data
  const getRoles = async () => {
    try {
      if (customerId === null) {
        return;
      }
      // Fetch stages data from API
      if (customerId) {
        const rolesResponse = await getAllRoles(customerId, false);
        const allroles = rolesResponse?.data?.roles;

        setCustomerOptions((prevState) => ({
          ...prevState,
          Roles: allroles,
        }));
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  // Function to fetch and set customer control fields data
  const getCustomerControl = async () => {
    try {
      if (customerId === null) {
        return;
      }
      // Check if customerId is available
      if (customerId !== null) {
        // Fetch customer control field data
        const customerData = await getCustomerControlField(customerId);
        // Extract and set customer control fields
        const controlFields = customerData?.data?.cust[0].modules[0];
        const promptTabs = controlFields.tabs.filter(
          (tab) => tab.tab_name === "Users"
        );
        setPromptTabs(promptTabs[0].tables[0].headers);
        setCustomerControlFields(controlFields);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  const checkingFirstname = (rowData) => {
    return (
      <div>
        {
          <div>
            {rowData.firstname != null && rowData.firstname != ""
              ? rowData.firstname
              : rowData.firstname}
          </div>
        }
      </div>
    );
  };
  const checkingSurname = (rowData) => {
    return <div>{<div>{rowData.surname}</div>}</div>;
  };
  const checkingUsername = (rowData) => {
    return <div className="form-label-text text-left mr-20 pointer mar-l-5">{rowData.username}</div>;
  };
  const checkingRolename = (rowData) => {
    return <div>{<div>{rowData.role_name}</div>}</div>;
  };
  const checkingEmail = (rowData) => {
    return <div>{<div>{rowData.email}</div>}</div>;
  };
  const checkingStatus = (rowData) => {
    return <div>{<div>{rowData.status}</div>}</div>;
  };
  const consent = (rowData) => {
    const iconColor = rowData.accept_gdpr === true ? "green" : "red";

    return (
      <div>
        {
          <div>
            {/* Render check or cross-circle icon based on option_status */}
            <InputIcon
              className={
                rowData.accept_gdpr === true
                  ? "pi pi-check-circle"
                  : "pi pi-times-circle"
              }
              style={{ color: iconColor }}
            />
          </div>
        }
      </div>
    );
  };

  // Define column configuration for the data table
  const columns = [
    {
      field: "username",
      header: promptTabs[2]?.display_name ? promptTabs[2]?.display_name : "",
      body: checkingUsername,
      headerClassName: "header-datatable",
      className: "row-datatable",
      sortable: true
    },
    {
      field: "firstname", // Field name for the column data
      header: promptTabs[0]?.display_name ? promptTabs[0]?.display_name : "", // Header text displayed in the table header
      body: checkingFirstname, // Function to render the cell content for this column
      // style: { width: "30%" }, // Inline style for the column
      headerClassName: "header-datatable",
      className: "row-datatable",
      sortable: true
    },
    {
      field: "surname",
      header: promptTabs[1]?.display_name ? promptTabs[1]?.display_name : "",
      body: checkingSurname,
      headerClassName: "header-datatable",
      className: "row-datatable",
      sortable: true
    },

    {
      field: "role_name",
      header: promptTabs[3]?.display_name ? promptTabs[3]?.display_name : "",
      body: checkingRolename,
      headerClassName: "header-datatable",
      className: "row-datatable",
      sortable: true
    },
    {
      field: "email",
      header: promptTabs[4]?.display_name ? promptTabs[4]?.display_name : "",
      body: checkingEmail,
      headerClassName: "header-datatable",
      className: "row-datatable",
      sortable: true
    },
    {
      field: "status",
      header: promptTabs[5]?.display_name ? promptTabs[5]?.display_name : "",
      body: checkingStatus,
      headerClassName: "header-datatable",
      className: "row-datatable",
      sortable: true
    },
    {
      field: "accept_gdpr",
      header: promptTabs[6]?.display_name ? promptTabs[6]?.display_name : "",
      body: consent,
      headerClassName: "header-datatable",
      className: "row-datatable",
      sortable: true
    },
  ];
  const show = (position) => {
    const enduserStr = localStorage.getItem("user_privileges");
    if (enduserStr) {
      const enduser = JSON.parse(enduserStr);
      if (enduser[0].user_readwrite) {
        setPosition(position);
        setVisible(true);
      } else {
        toastRef.current.showToast({
          type: "error",
          message: `You dont have permission to add user`,
        });
      }
    }
  };

  const showEdit = (position) => {
    setPosition(position);
    setVisibleEdit(true);
  };

  const rowClick = async (data) => {
    try {
      const enduserStr = localStorage.getItem("user_privileges");
      if (enduserStr === null) {
        toastRef.current.showToast({
          type: 'error',
          message: 'Missing user data'
        });
        return;
      }
      const enduser = JSON.parse(enduserStr);
      if (enduser && enduser[0].user_readwrite) {
        if (data?._id) {
          const pmptData = await getuserbyid(data._id);
          setEditUser(pmptData?.data);
          showEdit("right");
        }
      } else {
        toastRef.current.showToast({
          type: "error",
          message: `You dont have permission to edit user`,
        });
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e);
    setLazyParams({
      ...lazyParams,
      first: 0, // Reset to first page on new search
      page: 0
    });

    // filteredUsersArray(e.target.value);
  };
  const handleClearFilter = () => {
    setSearchQuery("");
    setLazyParams({
      ...lazyParams,
      first: 0, // Reset to first page on new search
      page: 0
    });
    filteredUsersArray("");
    getCustomerField();
  };

  /**
   * Filters the customer reference data based on the provided query.
   * If the query is empty, it retrieves the full customer field data.
   *
   * @param {string} query - The search query to filter the customer reference data.
   */
  const filteredUsersArray = (query) => {
    // Check if the query is not empty
    const lowerCaseQuery = query.toLowerCase();

    if (lowerCaseQuery) {
      setSearchedLength(lowerCaseQuery.length);
    }

    // Check if the query is not empty
    if (lowerCaseQuery) {
      // Filter the customer reference data
      const filteredData = custmerReferenceData.filter((item) => {
        // Check if any value in the item includes the query string
        return Object.values(item).some((value) =>
          value?.toString().toLowerCase().includes(lowerCaseQuery)
        );
      });
      // Update the state with the filtered data
      setCustmerReferenceData(filteredData);
    } else {
      getCustomerField();
    }
  };

  const handleHide = () => {
    setVisible(false);
    getCustomerField();
    handleClearFilter();
  };

  const handleHideEdit = () => {
    setVisibleEdit(false);
    getCustomerField();
    handleClearFilter();
  };
  const onPage = (event) => {
    setLazyParams({
      ...lazyParams,
      first: event.first,
      rows: event.rows,
      page: event.page,
    });
  };

  const onSort = (e) => {
    let newSortField = e.sortField;
    let newSortOrder = e.sortOrder;

    // Check if the same column is clicked
    if (lazyParams.sortField === newSortField) {
      // If currently sorted ascending, switch to descending
      if (lazyParams.sortOrder === 1) {
        newSortOrder = -1; // Set to descending
      }
      // If currently sorted descending, remove sorting
      else if (lazyParams.sortOrder === -1) {
        newSortField = 'last_login'; // Remove sorting
        newSortOrder = -1; // Remove sorting
      }
    }
    setLazyParams((prevParams) => ({
      ...prevParams,
      sortField: newSortField,
      sortOrder: newSortOrder,
    }));
  };

  const handleButtonClick = () => {
    setShowVideo(true);
  };

  const closeVideo = () => {
      setShowVideo(false);
  };

  return (
    <div className="group-table-component">
      <ToastElement ref={toastRef} />
      <Loader loading={loading} />
      <div className="header-design">
        <div>
          <p className="fs-16 fw-600 mar-b-3">
            {_.find(customerControlFields?.tabs, { tab_name: "Users" })?.display_name}
          </p>
        </div>
					<ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
        {/* <ButtonElement className="upload-button" type="button" icon="pi pi-question" /> */}
      </div>
      <div className="group-table-buttons">
        <div className="delete-button">
        </div>
        <div className="group-table-search">
          <HeaderSearchBar
            value={searchQuery}
            onChange={(e) => handleSearchChange(e)}
            onClick={handleClearFilter}
          />
          <ButtonElement
            className="clear-filter-button"
            type="button"
            icon="pi pi-plus"
            label="New"
            onClick={() => show("right")}
          />
        </div>
      </div>

      <CreateNewUsers
        visible={visible}
        position={position}
        customerId={customerId}
        customerControlFields={customerControlFields}
        onHide={handleHide}
        customerOptions={customerOptions}
        havingBranch={havingBranch}
        branchAdmin={branchAdmin}
        adminVisible={adminVisible}
        branch={branch}
      />
      <EditUsers
        visible={visibleEdit}
        position={position}
        customerId={customerId}
        customerControlFields={customerControlFields}
        editUser={editUser}
        onHide={handleHideEdit}
        customerOptions={customerOptions}
        havingBranch={havingBranch}
        branchAdmin={branchAdmin}
        adminVisible={adminVisible}
        branch={branch}
      />
      <DataTable
        value={custmerReferenceData}
        columns={columns}
        searchQuery={searchQuery}
        // removeField={removeField}
        rowClick={rowClick}
        usageLog={true}
        dataKey="_id"
        onPage={onPage}
        lazyParams={lazyParams}
        totalRecords={totalRecords}
        onSort={onSort}
      />


      {/* <Dialog
        visible={deleteProductDialog}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={deleteProductDialogFooter}
        onHide={hideDeleteProductDialog}
        className="table-dialog width-32"
      >
        <div className="confirmation-content">
          {updatedReferenceData && (
            <span>
              {updatedReferenceData.length > 1 ? (
                <span className="table-description">
                  Are you sure you want to delete{" "}
                  {updatedReferenceData.map((item, index) => (
                    <b key={index}>
                      {item.firstname}
                      {index < updatedReferenceData.length - 1 ? "," : ""}
                    </b>
                  ))}
                  ?
                </span>
              ) : (
                <span className="table-description">
                  Are you sure you want to delete{" "}
                  <b>{updatedReferenceData[0]?.firstname}</b>?
                </span>
              )}
            </span>
          )}
        </div>
      </Dialog> */}

      <Dialog id="videoModal" visible={showVideo}
				breakpoints={{
				'1200px': '80vw',    // Larger modal on bigger screens
				'1024px': '85vw',    // Slightly smaller for medium screens
				'769': '90vw',     // Responsive on tablets
				'641px': '95vw',     // Almost full-width on mobile
				}}
				modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
			>
				<div className="video-overlay">
					<div className="video-container">
						<PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_user_class" />
					</div>
				</div>
			</Dialog>
    </div>
  );
}
